import { Component, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ImagesService } from '../../services/image-service/images.service';
import { SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-grid-image-cell',
  standalone: false,
  templateUrl: './grid-image-cell.component.html',
  styleUrls: ['./grid-image-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridImageCellComponent implements ICellRendererAngularComp {
  blobUrl: SafeUrl | null = null;
  isLoading = true;

  constructor(private imageService: ImagesService, private cdr: ChangeDetectorRef) {}

  agInit(params: any): void {
    this.imageService.getSecureImageUrl(params.value).subscribe(url => {
      this.blobUrl = url;
      this.isLoading = false;
      this.cdr.markForCheck();
    }, err => {
      this.isLoading = false;
    });
  }


  refresh(params: any): boolean {
    return false;
  }
}
